{
    "Profile_Drivers_CriminalConviction.criminalConviction": "Criminal Conviction",
    "Profile_Drivers_CriminalConviction.criminalConvictionDetails": "Criminal Conviction Details",
    "Profile_Drivers_CriminalConviction.dateOfConviction": "Date of Conviction",
    "Profile_Drivers_CriminalConviction.convictionReason": "Conviction Reason"
}
